/**
 * @module module/triage-page-sk
 * @description <h2><code>triage-page-sk</code></h2>
 *
 * Allows triaging clusters.
 *
 * TODO(jcgregorio) Needs working demo page and tests.
 *
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TriagePageSk", {
    enumerable: true,
    get: function() {
        return TriagePageSk;
    }
});
const _html = require("lit/html.js");
const _define = require("../../../elements-sk/modules/define");
const _object = require("../../../infra-sk/modules/object");
const _query = require("../../../infra-sk/modules/query");
const _jsonOrThrow = require("../../../infra-sk/modules/jsonOrThrow");
const _stateReflector = require("../../../infra-sk/modules/stateReflector");
const _errorMessage = require("../errorMessage");
const _ElementSk = require("../../../infra-sk/modules/ElementSk");
require("../../../elements-sk/modules/spinner-sk");
require("../cluster-summary2-sk");
require("../commit-detail-sk");
require("../day-range-sk");
require("../triage-status-sk");
const _keyboardshortcuts = require("../common/keyboard-shortcuts");
require("../keyboard-shortcuts-help-sk/keyboard-shortcuts-help-sk");
require("../../../elements-sk/modules/icons/help-icon-sk");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _full_summary(frame, summary) {
    return {
        frame,
        summary,
        triage: {
            message: '',
            status: 'untriaged'
        }
    };
}
let TriagePageSk = class TriagePageSk extends _ElementSk.ElementSk {
    onOpenHelp() {
        const help = this.querySelector('keyboard-shortcuts-help-sk');
        help.open();
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.firstConnect) {
            return;
        }
        this.firstConnect = true;
        this._render();
        this.dialog = this.querySelector('dialog');
        this.stateHasChanged = (0, _stateReflector.stateReflector)(()=>this.state, (state)=>{
            this.state = state;
            // Support the legacy query parameter.
            if (this.state.filter) {
                this.state.alert_filter = this.state.filter;
            }
            this._render();
            this.updateRange();
        });
        window.addEventListener('keydown', this.keyDown);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('keydown', this.keyDown);
    }
    onTriagePositive() {
        const clusterSummary = this.querySelector('cluster-summary2-sk');
        if (clusterSummary) {
            clusterSummary.triage = _object_spread_props(_object_spread({}, clusterSummary.triage), {
                status: 'positive'
            });
            clusterSummary.updateStatus();
        }
    }
    onTriageNegative() {
        const clusterSummary = this.querySelector('cluster-summary2-sk');
        if (clusterSummary) {
            clusterSummary.triage = _object_spread_props(_object_spread({}, clusterSummary.triage), {
                status: 'negative'
            });
            clusterSummary.updateStatus();
        }
    }
    onOpenReport() {
        const clusterSummary = this.querySelector('cluster-summary2-sk');
        if (clusterSummary) {
            clusterSummary.openShortcut();
        }
    }
    commitsChange(e) {
        this.state.subset = e.target.value;
        this.updateRange();
        this.stateHasChanged();
    }
    filterChange(e) {
        this.state.alert_filter = e.target.value;
        this.updateRange();
        this.stateHasChanged();
    }
    triaged(e) {
        e.stopPropagation();
        const body = {
            cid: e.detail.columnHeader.offset,
            triage: e.detail.triage,
            alert: this.dialogState.alert,
            cluster_type: this.dialogState.cluster_type
        };
        this.dialog.close();
        this._render();
        if (this.triageInProgress) {
            (0, _errorMessage.errorMessage)('A triage request is in progress.');
            return;
        }
        this.triageInProgress = true;
        fetch('/_/triage/', {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(_jsonOrThrow.jsonOrThrow).then((json)=>{
            this.triageInProgress = false;
            this._render();
            if (json.bug) {
                // Open the bug reporting page in a new window.
                window.open(json.bug, '_blank');
            }
        }).catch((msg)=>{
            if (msg) {
                (0, _errorMessage.errorMessage)(msg, 10000);
            }
            this.triageInProgress = false;
            this._render();
        });
    }
    close() {
        this.dialog.close();
    }
    stepUpAt(index) {
        const dir = this.reg.header[index].direction;
        return dir === 'UP' || dir === 'BOTH';
    }
    stepDownAt(index) {
        const dir = this.reg.header[index].direction;
        return dir === 'DOWN' || dir === 'BOTH';
    }
    notBoth(index) {
        return this.reg.header[index].direction !== 'BOTH';
    }
    alertAt(index) {
        return this.reg.header[index];
    }
    encQueryFrom(colIndex) {
        return encodeURIComponent(this.reg.header[colIndex].query);
    }
    hashFrom(rowIndex) {
        return this.reg.table[rowIndex].cid.offset;
    }
    openKeys(e) {
        const query = {
            keys: e.detail.shortcut,
            begin: e.detail.begin,
            end: e.detail.end,
            xbaroffset: e.detail.xbar.offset,
            num_commits: 50,
            request_type: 1
        };
        window.open(`/e/?${(0, _query.fromObject)(query)}`, '_blank');
    }
    rangeChange(e) {
        this.state.begin = Math.floor(e.detail.begin);
        this.state.end = Math.floor(e.detail.end);
        this.stateHasChanged();
        this.updateRange();
    }
    updateRange() {
        if (this.refreshRangeInProgress) {
            return;
        }
        if ((0, _object.equals)(this.lastState, this.state)) {
            return;
        }
        this.lastState = (0, _object.deepCopy)(this.state);
        this.refreshRangeInProgress = true;
        this._render();
        const body = this.state;
        fetch('/_/reg/', {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(_jsonOrThrow.jsonOrThrow).then((json)=>{
            this.refreshRangeInProgress = false;
            this.reg = json;
            this.calc_all_filter_options();
            this._render();
        }).catch((msg)=>{
            if (msg) {
                (0, _errorMessage.errorMessage)(msg, 10000);
            }
            this.refreshRangeInProgress = false;
            this._render();
        });
    }
    calc_all_filter_options() {
        const opts = [
            {
                value: 'ALL',
                title: 'Show all alerts.',
                display: 'Show all alerts.'
            },
            {
                value: 'OWNER',
                title: "Show only the alerts owned by the logged in user (or all alerts if the user doesn't own any alerts).",
                display: 'Show alerts you own.'
            }
        ];
        if (this.reg && this.reg.categories) {
            this.reg.categories.forEach((cat)=>{
                const displayName = cat || '(default)';
                opts.push({
                    value: `cat:${cat} `,
                    title: `Show only the alerts in the ${displayName} category.`,
                    display: `Category: ${displayName} `
                });
            });
        }
        this.allFilterOptions = opts;
    }
    constructor(){
        super(TriagePageSk.template);
        this.dialogState = {};
        this.lastState = {};
        this.dialog = null;
        this.allFilterOptions = [];
        this.keyDown = (e)=>{
            if (!this.dialog || !this.dialog.open) {
                return;
            }
            // Ignore if typing in input
            if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
                return;
            }
            (0, _keyboardshortcuts.handleKeyboardShortcut)(e, this);
        };
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.stateHasChanged = ()=>{};
        this.triage_start = (e)=>{
            this.dialogState = e.detail;
            this._render();
            const dialog = this.querySelector('#triage-dialog');
            if (dialog) {
                this.dialog = dialog;
                try {
                    if (!this.dialog.open) {
                        this.dialog.showModal();
                    }
                } catch (err) {
                    (0, _errorMessage.errorMessage)(`Failed to open dialog: ${err}`);
                    // Fallback to non-modal open if showModal fails
                    this.dialog.open = true;
                }
            }
        };
        const now = Math.floor(Date.now() / 1000);
        // The state to reflect to the URL, also the body of the POST request
        // we send to /_/reg/.
        this.state = {
            begin: now - 2 * 7 * 24 * 60 * 60,
            end: now,
            subset: 'untriaged',
            alert_filter: 'ALL',
            filter: ''
        };
        this.reg = {
            header: [],
            table: [],
            categories: []
        };
        this.allFilterOptions = [];
        this.triageInProgress = false;
        this.refreshRangeInProgress = false;
        // The ID of the setInterval that is updating _currentClusteringStatus.
        this.statusIntervalID = 0;
        this.firstConnect = false;
    }
};
(()=>{
    TriagePageSk.template = (ele)=>(0, _html.html)`
    <header>
      <details>
        <summary>Filter</summary>
        <h3>Which commits to display.</h3>
        <select @input=${ele.commitsChange}>
          <option
            ?selected=${ele.state.subset === 'all'}
            value="all"
            title="Show results for all commits in the time range.">
            All
          </option>
          <option
            ?selected=${ele.state.subset === 'regressions'}
            value="regressions"
            title="Show only the commits with regressions in the given time range regardless of triage status.">
            Regressions
          </option>
          <option
            ?selected=${ele.state.subset === 'untriaged'}
            value="untriaged"
            title="Show only commits with untriaged regressions in the given time range.">
            Untriaged
          </option>
        </select>

        <h3>Which alerts to display.</h3>

        <select @input=${ele.filterChange}>
          ${TriagePageSk.allFilters(ele)}
        </select>
      </details>
      <details>
        <summary>Range</summary>
        <day-range-sk
          @day-range-change=${ele.rangeChange}
          begin=${ele.state.begin}
          end=${ele.state.end}></day-range-sk>
      </details>
      <button
        class="action"
        @click=${ele.onOpenHelp}
        title="Keyboard Shortcuts"
        style="margin-left: auto;">
        <help-icon-sk></help-icon-sk>
      </button>
    </header>
    <spinner-sk ?active=${ele.triageInProgress || ele.refreshRangeInProgress}></spinner-sk>

    <dialog id="triage-dialog">
      <cluster-summary2-sk
        @open-keys=${ele.openKeys}
        @triaged=${ele.triaged}
        .full_summary=${ele.dialogState.full_summary}
        .triage=${ele.dialogState.triage}
        .alert=${ele.dialogState.alert}></cluster-summary2-sk>
      <div class="buttons">
        <button @click=${ele.close}>Close</button>
      </div>
    </dialog>
    <keyboard-shortcuts-help-sk .handler=${ele}></keyboard-shortcuts-help-sk>

    <table @start-triage=${ele.triage_start}>
      <tr>
        <th>Commit</th>
        ${TriagePageSk.headers(ele)}
      </tr>
      <tr>
        <th></th>
        ${TriagePageSk.subHeaders(ele)}
      </tr>
      ${TriagePageSk.rows(ele)}
    </table>
  `;
})();
(()=>{
    TriagePageSk.rows = (ele)=>ele.reg.table.map((row, rowIndex)=>(0, _html.html)`
        <tr>
          <td class="fixed">
            <commit-detail-sk .cid=${row.cid}></commit-detail-sk>
          </td>
          ${TriagePageSk.columns(ele, row, rowIndex)}
        </tr>
      `);
})();
(()=>{
    TriagePageSk.columns = (ele, row, rowIndex)=>row.columns.map((col, colIndex)=>{
            const ret = [];
            if (ele.stepDownAt(colIndex)) {
                ret.push((0, _html.html)`
          <td class="cluster">${TriagePageSk.lowCell(ele, rowIndex, col, colIndex)}</td>
        `);
            }
            if (ele.stepUpAt(colIndex)) {
                ret.push((0, _html.html)`
          <td class="cluster">${TriagePageSk.highCell(ele, rowIndex, col, colIndex)}</td>
        `);
            }
            if (ele.notBoth(colIndex)) {
                ret.push((0, _html.html)` <td></td> `);
            }
            return ret;
        });
})();
(()=>{
    TriagePageSk.lowCell = (ele, rowIndex, col, colIndex)=>{
        if (col && col.low) {
            return (0, _html.html)`
        <triage-status-sk
          .alert=${ele.alertAt(colIndex)}
          .cluster_type=${'low'}
          .full_summary=${_full_summary(col.frame, col.low)}
          .triage=${col.low_status}></triage-status-sk>
      `;
        }
        return (0, _html.html)`
      <a
        title="No clusters found."
        href="/g/c/${ele.hashFrom(rowIndex)}?query=${ele.encQueryFrom(colIndex)}">
        ∅
      </a>
    `;
    };
})();
(()=>{
    TriagePageSk.highCell = (ele, rowIndex, col, colIndex)=>{
        if (col && col.high) {
            return (0, _html.html)`
        <triage-status-sk
          .alert=${ele.alertAt(colIndex)}
          .cluster_type=${'high'}
          .full_summary=${_full_summary(col.frame, col.high)}
          .triage=${col.high_status}></triage-status-sk>
      `;
        }
        return (0, _html.html)`
      <a
        title="No clusters found."
        href="/g/c/${ele.hashFrom(rowIndex)}?query=${ele.encQueryFrom(colIndex)}">
        ∅
      </a>
    `;
    };
})();
(()=>{
    TriagePageSk.subHeaders = (ele)=>ele.reg.header.map((_, index)=>{
            const ret = [];
            if (ele.stepDownAt(index)) {
                ret.push((0, _html.html)` <th>Low</th> `);
            }
            if (ele.stepUpAt(index)) {
                ret.push((0, _html.html)` <th>High</th> `);
            }
            // If we have only one of High or Low we stuff in an empty th to match
            // colspan=2 above.
            if (ele.notBoth(index)) {
                ret.push((0, _html.html)` <th></th> `);
            }
            return ret;
        });
})();
(()=>{
    TriagePageSk.headers = (ele)=>ele.reg.header.map((item)=>{
            let displayName = item.display_name;
            if (!item.display_name) {
                displayName = item.query.slice(0, 10);
            }
            // The colspan=2 is important since we will have two columns under each
            // header, one for high and one for low.
            return (0, _html.html)`
        <th colspan="2">
          <a href="/a/?${item.id_as_string}">${displayName}</a>
        </th>
      `;
        });
})();
(()=>{
    TriagePageSk.allFilters = (ele)=>ele.allFilterOptions.map((o)=>(0, _html.html)`
        <option ?selected=${ele.state.alert_filter === o.value} value=${o.value} title=${o.title}>
          ${o.display}
        </option>
      `);
})();
(0, _define.define)('triage-page-sk', TriagePageSk);
